import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ClsGrid from "../../Common/clsGrid";

const ViewPoints = () => {
  const location = useLocation();
  const [school, setSchool] = useState("");
  const [family, setFamily] = useState("");
  const [login, setLogin] = useState("");

  const [summary, setSummary] = useState<any>({});
  const [data, setData] = useState<any[]>([]);
  const API_BASE = process.env.REACT_APP_DOCUMENT_LINK || "https://staging.sysadmin.elearnoncloud.com/";

  const syncQueryParams = () => {
    const params = new URLSearchParams(location.search);
    setSchool(params.get("C") || "");
    setFamily(params.get("F") || "");
    setLogin(params.get("L") || "");
  };

  const fetchData = async () => {
    const res = await fetch(
      `${API_BASE}api/student-points/?school=${school}&family=${family}&login=${login}`
    );
    const json = await res.json();

    setSummary(json.summary);
    setData(Array.isArray(json.data) ? json.data : []);
  };

  useEffect(() => {
    syncQueryParams();
  }, [location.search]);

  useEffect(() => {
    if (school || family || login) {
      fetchData();
    }
  }, [school, family, login]);

  return (
    <div style={{ padding: "10px", fontFamily: "Arial" }}>
      {/* 🔹 FILTERS */}
      <div>
        SchoolCode:
        <input value={school} onChange={(e) => setSchool(e.target.value)} />

        FamilyCode:
        <input value={family} onChange={(e) => setFamily(e.target.value)} />

        Login:
        <input value={login} onChange={(e) => setLogin(e.target.value)} />

        <button onClick={fetchData}>VIEW</button>

        <button onClick={() => window.close()}>CLOSE</button>
      </div>

      {/* 🔹 SUMMARY */}
      <div style={{ marginTop: "10px", fontWeight: "bold" }}>
        Points details for <span style={{ color: "maroon" }}>{summary?.name}</span>

        &nbsp;&nbsp; Current Points:
        <span style={{ color: "maroon" }}>{summary?.points}</span>

        &nbsp;&nbsp; Bonus Chests:
        <span style={{ color: "maroon" }}>{summary?.bonus}</span>
      </div>

      {/* 🔹 GRID */}
      <ClsGrid
        columns={[
          { key: "date", label: "Done On" },
          { key: "mode", label: "Selection Mode" },
          { key: "dic", label: "DicFile" },
          { key: "dicName", label: "Dic Name" },
          { key: "lesson", label: "LessonCode" },
          { key: "activity", label: "Activity" },
          { key: "times", label: "Times Done" },
          { key: "score", label: "Score" },
          { key: "bricks", label: "Bricks" },
          { key: "earned", label: "Earned" },
          { key: "used", label: "Used" },
          { key: "balance", label: "Balance" },
          { key: "remarks", label: "Remarks" },
        ]}
        data={data}
        pagination
      />
    </div>
  );
};

export default ViewPoints;